import React, { useState, useEffect } from 'react';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
} from '@coreui/react'
import { FaBars, FaSearch } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight } from 'react-icons/bs';
import '../../assets/css/mainstyle.css';
import Adminprofil from '../../assets/images/adminprofil.png';
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';

const Speciality = () => {

    const [UserData, setUserData] = useState([]);  

    useEffect(() => {
      const fetchLoggedUserData = async () => {
        try {
          const response = await api.get('api/usersprofile');
  
          setUserData(response.data);
        } catch (error) {
          toast.error("Failed to fetch data");
        }
      };
      fetchLoggedUserData();
    }, []);

    return (
        <div className="dashboard-header" >
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        {/* Barre de recherche */}
                        <div className="pagetittle col">
                            <h4><b>Speciality Management</b></h4>
                        </div>
                        {/* Profil utilisateur */}

                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex align-items-center ms-auto">
                                        <img src={UserData?.picture || Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2">{UserData.firstname} {UserData.lastname}</span>
                                            <p className="ms-2">{UserData.role?.name.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>

            <div className="Patientlist mt-2"  >
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <section className='adddepartment newregistermodal'>
                                        <div className='d-flex align-items-center cardheader'>
                                            <span className='me-3' style={{ width: '70px', height: '5px', background: '#0056B3' }}></span>
                                            <h4>Add Speciality</h4>
                                        </div>
                                        <form>
                                            <div className="form-group">
                                                <label htmlFor="name">Name</label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    placeholder="Casos Billal"
                                                />
                                            </div>

                                            <div className="form-group ">
                                                <textarea
                                                    type="text"
                                                    name="description"
                                                    id="description"
                                                    placeholder="Description"
                                                />
                                            </div>

                                            <div className="form-group d-flex justify-content-center">
                                                <CButton type='submit' className="ms-auto d-flex align-items-center" active tabIndex={-1}>
                                                    <BsPersonPlus className='mx-2' /> Add new speciality
                                                </CButton>
                                            </div>
                                        </form>
                                    </section>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>
        </div >


    );
}

export default Speciality;
